import { Link } from "react-router-dom";
import { COMPANY } from "@/data/site";

export default function Logo({ variant = "dark", className = "" }) {
  // variant: "dark" (for light backgrounds) or "light" (for dark backgrounds)
  const textColor = variant === "light" ? "text-white" : "text-[#111111]";
  return (
    <Link to="/" aria-label="CompuBrain AI home" data-testid="logo-link" className={`flex items-center gap-2.5 ${className}`}>
      {variant === "light" ?(
        <img
          src='/compuBrain_White_Logo.png'
          alt="CompuBrain AI monogram"
          width={30}
          height={30}
          className={`h-7 w-auto`}
        />
      ):(
        <img
          src='/compuBrain_Logo.png'
          alt="CompuBrain AI monogram"
          width={30}
          height={30}
          className={`h-7 w-auto`}
        />
      )}
    </Link>
  );
}
